import { Controller } from "@hotwired/stimulus";
import JSConfetti from "js-confetti";

export default class extends Controller {
  static values = {
    score: Number,
    distance: Number,
    isSummaryPage: Boolean,
  };
  static targets = ["scoreDisplay"];

  jsConfetti = null;

  connect() {
    this.jsConfetti = new JSConfetti();

    if (this.hasScoreDisplayTarget) {
      this.animateScore();
    }

    const distanceElement = this.targets.find("distanceDisplay");
    if (distanceElement && this.hasDistanceValue) {
      this.animateDistance(distanceElement);
    }
  }

  async animateScore() {
    const scoreElement = this.scoreDisplayTarget;
    const finalScore = this.scoreValue;
    scoreElement.textContent = 0; // Always start display at 0

    if (finalScore === 0) {
      this.shakeElement(scoreElement);
    } else {
      await this.countUp(scoreElement, finalScore, 0, "");

      // Determine the score threshold based on the page type
      const scoreThreshold = this.isSummaryPageValue ? 15000 : 3500;
      const intensity = this.isSummaryPageValue ? "high" : "normal";

      // Check against the appropriate threshold
      if (finalScore > scoreThreshold) {
        this.popConfetti(intensity);
      }
    }
  }

  animateDistance(distanceElement) {
    const finalDistance = this.distanceValue;
    if (typeof finalDistance !== "number" || isNaN(finalDistance)) {
      distanceElement.textContent = "Error"; // Show error if value is bad
      return;
    }
    distanceElement.textContent = "0.0 km"; // Start display at 0.0 km

    this.countUp(distanceElement, finalDistance, 1, " km");
  }

  countUp(element, finalValue, decimalPlaces, suffix) {
    return new Promise((resolve, reject) => {
      let currentValue = 0;
      const duration = 1000; // Animation duration in milliseconds
      const stepTime = 20; // Time between steps in milliseconds
      const steps = duration / stepTime;
      const increment = finalValue / steps;

      let stepCount = 0; // Add counter for debugging infinite loops

      element.textContent = currentValue.toFixed(decimalPlaces) + suffix; // Initial display

      const interval = setInterval(() => {
        stepCount++;
        if (stepCount > steps * 1.5) {
          // Safety break
          element.textContent = finalValue.toFixed(decimalPlaces) + suffix;
          clearInterval(interval);
          reject(new Error("Animation stuck")); // Reject the promise
          return;
        }

        currentValue += increment;
        let displayValue;
        if (currentValue >= finalValue) {
          displayValue = finalValue.toFixed(decimalPlaces) + suffix;
          element.textContent = displayValue;
          clearInterval(interval);
          resolve(); // Resolve the promise when done
        } else {
          displayValue = currentValue.toFixed(decimalPlaces) + suffix;
          element.textContent = displayValue;
        }
      }, stepTime);
    });
  }

  shakeElement(element) {
    element.classList.add("shake");
    // Optional: Remove the class after the animation completes
    element.addEventListener(
      "animationend",
      () => {
        element.classList.remove("shake");
      },
      { once: true }
    );
  }

  popConfetti(intensity = "normal") {
    let options = {
      confettiNumber: 150,
    };

    if (intensity === "high") {
      // Increase confetti count for high intensity
      options.confettiNumber = 100;
      options.emojis = ["🌊", "🏄‍♀️", "🏄", "🏆"]; // Optional: add some celebratory emojis
      options.emojiSize = 50;
    }

    this.jsConfetti.addConfetti(options);
  }
}
